import React, { useEffect } from "react";

export default function AgeGate({ onAccept, onDecline, onAfterUnmount }) {
  // This cleanup fires the moment React removes AgeGate from the DOM.
  // Equivalent to detecting a script tag being removed from document.head.
  useEffect(() => {
    return () => {
      onAfterUnmount?.();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div
      className="fixed inset-0 z-[10100] flex items-center justify-center bg-black/60 px-4"
      style={{ pointerEvents: "all" }}
      aria-modal="true"
      role="dialog"
      aria-labelledby="age-gate-heading"
    >
      <div
        className="w-full max-w-md bg-white border border-[#1A1A1A] p-10"
        style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
      >
        {/* Wordmark */}
        <p className="font-sans text-[9px] uppercase tracking-[0.25em] text-neutral-400 font-semibold mb-6">
          Arvay — Age Verification
        </p>

        {/* Headline */}
        <h2
          id="age-gate-heading"
          className="text-2xl font-medium tracking-tight text-[#000000] leading-snug mb-4"
        >
          You must be 17 or older to use Arvay
        </h2>

        {/* Body */}
        <p className="font-sans text-sm text-[#444444] leading-relaxed mb-8">
          Arvay aggregates news, financial data, and community content that may
          include mature themes. By continuing, you confirm that you are 17 years
          of age or older.
        </p>

        {/* Buttons */}
        <div className="flex flex-col gap-3">
          <button
            onClick={onAccept}
            data-testid="age-gate-accept"
            className="w-full bg-black text-white font-sans text-[10px] uppercase tracking-[0.2em] font-semibold py-3.5 hover:bg-neutral-800 transition-colors focus:outline-none focus:ring-1 focus:ring-black"
          >
            I Accept
          </button>
          <button
            onClick={onDecline}
            data-testid="age-gate-decline"
            className="w-full bg-white text-[#1A1A1A] border border-[#1A1A1A] font-sans text-[10px] uppercase tracking-[0.2em] font-semibold py-3.5 hover:bg-neutral-50 transition-colors focus:outline-none focus:ring-1 focus:ring-black"
          >
            I Decline
          </button>
        </div>
      </div>
    </div>
  );
}
